import {
    greekPrefixes,
    greekSuffixes,
    norsePrefixes,
    norseSuffixes,
    turkishPrefixes,
    turkishSuffixes
} from '@/constants/mythologyNames';

export interface MythologyNameGeneratorOptions {
    count?: number;
    style?: 'greek' | 'norse' | 'turkish' | 'any';
}

export function generateMythologyNames(options: MythologyNameGeneratorOptions = {}): string[] {
    const count = options.count || 10;
    const style = options.style || 'any';
    const names: string[] = [];

    for (let i = 0; i < count; i++) {
        let currentStyle = style;
        if (currentStyle === 'any') {
            const styles = ['greek', 'norse', 'turkish'];
            currentStyle = styles[Math.floor(Math.random() * styles.length)] as 'greek' | 'norse' | 'turkish';
        }

        let prefix = '';
        let suffix = '';

        switch (currentStyle) {
            case 'greek':
                prefix = greekPrefixes[Math.floor(Math.random() * greekPrefixes.length)];
                suffix = greekSuffixes[Math.floor(Math.random() * greekSuffixes.length)];
                break;
            case 'norse':
                prefix = norsePrefixes[Math.floor(Math.random() * norsePrefixes.length)];
                suffix = norseSuffixes[Math.floor(Math.random() * norseSuffixes.length)];
                break;
            case 'turkish':
                prefix = turkishPrefixes[Math.floor(Math.random() * turkishPrefixes.length)];
                suffix = turkishSuffixes[Math.floor(Math.random() * turkishSuffixes.length)];
                break;
        }

        names.push(`${prefix}${suffix}`);
    }

    return names;
}
